import { MaybeObservable, MaybeObservableArray, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import ko from "knockout";
import viewHtml from "./dropdown.html";

type OptionsTextFunc = (item: any) => string;

export interface IDropdownParams {
    value: KnockoutObservable<any>;
    autoSelectIfOnlyOne?: boolean;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    options: MaybeObservableArray<any>;
    optionsText?: string | OptionsTextFunc;
    optionsValue?: string;
    optionsCaption?: string;
    optionsAfterRender?: (option: HTMLElement, item: any) => void;
    preventBubble?: string;
    valueAllowUnset: boolean;
    attr?: MaybeObservableAttributes;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
}

ko.components.register("ko-dropdown", {
    viewModel: function (params: IDropdownParams) {
        this.value = params.value;

        this.required = createRequiredObservable(params.value);

        this.id = selectIdAttr("ko_dropdown", params.attr);

        this.label = selectLabel(params.meta, params.text);

        this.enable = createEnabler(params.enable, params.disable);

        this.options = params.options;

        this.optionsText = params.optionsText;

        this.optionsValue = params.optionsValue;

        this.optionsCaption = params.optionsCaption;

        this.optionsAfterRender = params.optionsAfterRender ? params.optionsAfterRender : () => {};

        this.preventBubble = params.preventBubble ? params.preventBubble : "";

        this.autoSelectIfOnlyOne = !!params.autoSelectIfOnlyOne;

        this.valueAllowUnset = params.valueAllowUnset ? params.valueAllowUnset : false;

        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off"
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
